<template>
    <apexchart
      type="bar"
      :height="height"
      class="activity-sparkline custom-apex-style"
      :options="chartOptions"
      :series="chartSeries"
    />
  </template>
  
  <script>
  import ApexCharts from "vue-apexcharts"
  
  export default {
    name: "ActivitySparkline",
    components: { apexchart: ApexCharts },
    props: {
      // Data points for the sparkline
      height: {
        type: Number,
        default: 40
      },
      series: {
        type: Array,
        required: true
      },
      // Primary color for the line/fill
      color: {
        type: String,
        default: "#1976d2"
      },
      // Optional x-axis categories (e.g., days of month). When provided, we show the x-axis.
      categories: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      chartOptions() {
        return {
          chart: {
            type: "bar",
            height: this.height,
            // Show axis when categories are provided; otherwise sparkline
            sparkline: { enabled: this.categories.length === 0 },
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '65%',
              borderRadius: 2
            }
          },
          stroke: {
            curve: "smooth",
            width: 1
          },
          dataLabels: { enabled: false },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "vertical",
              gradientToColors: [this.color],
              stops: [0, 100],
              opacityFrom: 0.6,
              opacityTo: 0.05
            }
          },
          markers: {
            size: 0
          },
          xaxis: {
            categories: this.categories,
            labels: {
              show: this.categories.length > 0,
              style: { fontSize: '9px' },
              rotate: 0,
              formatter: (val) => {
                // Show day number if YYYY-MM-DD
                if (typeof val === 'string' && val.length >= 10 && val[4] === '-') return val.slice(-2);
                return val;
              }
            },
            axisBorder: { show: this.categories.length > 0 },
            axisTicks: { show: this.categories.length > 0 },
            tooltip: { enabled: false }
          },
          yaxis: {
            show: false
          },
          grid: {
            show: this.categories.length > 0,
            borderColor: '#e0e0e0',
            strokeDashArray: 3,
            yaxis: { lines: { show: false } },
            xaxis: { lines: { show: false } }
          },
          tooltip: {
            theme: "dark",
            y: {
              formatter: val => val.toFixed(0)
            }
          },
          colors: [this.color]
        }
      },
      chartSeries() {
        return [
          {
            data: this.series
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .custom-apex-style {
    border-radius: 6px;
    overflow: hidden;
  }
  </style>
  